import { render, staticRenderFns } from "./activityCard.vue?vue&type=template&id=33f04260&scoped=true"
import script from "./activityCard.vue?vue&type=script&lang=ts"
export * from "./activityCard.vue?vue&type=script&lang=ts"
import style0 from "./activityCard.vue?vue&type=style&index=0&id=33f04260&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f04260",
  null
  
)

export default component.exports